import React from 'react';
import { Link } from 'react-router-dom';

const PortfolioManagement = () => {
  return (
    <div className="min-h-screen bg-[#0A0E23] text-white py-24 px-4">
      <div className="max-w-4xl mx-auto">
        <Link to="/support" className="text-blue-500 hover:underline mb-8 inline-block">
          ← Destek Sayfasına Dön
        </Link>
        
        <h1 className="text-4xl font-bold mb-8">Portföy Yönetimi 📊</h1>
        
        <div className="space-y-12">
          <section>
            <h2 className="text-2xl font-semibold mb-4">Varlık Takibi</h2>
            <p className="text-gray-300 mb-4">
              Varlıklarınızı nasıl takip edeceğiniz:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-300">
              <li>Canlı fiyat takibi</li>
              <li>Alım/Satım işlemlerini kaydetme</li>
              <li>Kar/Zarar analizi</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Rebalancing</h2>
            <p className="text-gray-300 mb-4">
              Portföy dengeleme nasıl yapılır:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-300">
              <li>Hedef ağırlıkları belirleme</li>
              <li>Sapmaları tespit etme</li>
              <li>Dengeleme önerilerini görüntüleme</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PortfolioManagement;